<style lang="scss">
@import "@/landing/dependencies.scss";
.feature-tabs {
  .tabs div,
  .theme--light.v-tabs > .v-tabs-bar {
    background-color: transparent;
  }

  .tabs {
    position: relative;
    z-index: 55;
    margin-top: $spacing5 * -1;
    .v-tabs-slider-wrapper .v-tabs-slider {
      background-color: $palette-primary-light !important;
    }
    section {
      @include breakpoints-down(sm) {
        margin: spacing(3, 0);
      }
    }
    ::v-deep .v-slide-group__prev.v-slide-group__prev--disabled {
      @include breakpoints-down(xs) {
        display: none !important;
      }
    }
    ::v-deep .v-slide-group__wrapper {
      @include breakpoints-down(xs) {
        overflow: auto;
      }
    }
  }

  .tab-content {
    position: relative;
    @include breakpoints-up(md) {
      padding: spacing(1, 4, 0);
    }
    section {
      position: relative;
      div {
        overflow: visible;
      }
    }
    h6 {
      margin-top: -50px;
      margin-bottom: 0;
    }
  }

  .tab-label {
    font-size: 18px;
    font-weight: $font-medium;
    letter-spacing: 0;
    padding: spacing(0, 5);
    border-bottom: 1px solid;
    @include use-theme(border-color, $light-text-disabled, $dark-text-disabled);
    @include breakpoints-down(xs) {
      font-size: 14px;
    }
    &.selected {
      @include use-theme(color, $palette-primary-main, $palette-primary-light);
    }
    .theme--dark & {
      color: $palette-primary-light;
    }
  }

  .illustration-center {
    perspective: 1000px;
    .figure.screen {
      display: block;
      // text-align: center;
      max-width: 700px;
      // margin: -50px auto 0;
      margin: 0 auto 0;
      transform: rotateY(0) rotateX(35deg) rotateZ(0deg) translate(0, -50px);
      img {
        margin: -50px auto 0;
        width: 100%;
      }
    }
  }
}
</style>

<template>
  <div class="feature-tabs last mb-0">
    <TitleMain align="center">
      <span>
        <span v-t="'Nii nbagu'" />
        <strong><span v-t="'Enterprise'" /></strong>
      </span>
    </TitleMain>
    <div class="tab">
      <v-row class="spacing6">
        <v-col v-if="!isMobile" class="pa-6" md="1" cols="12" />
        <v-col md="10" cols="12" class="pa-6">
          <v-tabs v-model="tab" class="tabs" color="primary" centered rounded>
            <v-tabs-slider color="primary" />
            <v-tab class="tab-label" href="#tab-1">Pellentesque</v-tab>
            <v-tab class="tab-label" href="#tab-2">Donec</v-tab>
            <v-tab class="tab-label" href="#tab-3">Vestibulum</v-tab>
            <v-tab-item value="tab-1">
              <div class="tab-content">
                <section>
                  <div class="illustration-center">
                    <figure class="figure screen">
                      <img :src="$asset(imgAPI.saas[14])" alt="screen" />
                    </figure>
                  </div>
                  <h6 class="text-center use-text-subtitle2">
                    {{
                      $t(
                        "We empowers your marketing, sales and services teams to collaborate across the entire customer lifecycle for more meaningful, memorable experiences.",
                      )
                    }}
                  </h6>
                </section>
              </div>
            </v-tab-item>
            <v-tab-item value="tab-2">
              <div class="tab-content">
                <section>
                  <div class="illustration-center">
                    <figure class="figure screen">
                      <img :src="$asset(imgAPI.saas[15])" alt="screen" />
                    </figure>
                  </div>
                  <h6 class="text-center use-text-subtitle2">
                    {{
                      $t(
                        "We empowers your marketing, sales and services teams to collaborate across the entire customer lifecycle for more meaningful, memorable experiences.",
                      )
                    }}
                  </h6>
                </section>
              </div>
            </v-tab-item>
            <v-tab-item value="tab-3">
              <div class="tab-content">
                <section>
                  <div class="illustration-center">
                    <figure class="figure screen">
                      <img :src="$asset(imgAPI.saas[16])" alt="screen" />
                    </figure>
                  </div>
                  <h6 class="text-center use-text-subtitle2">
                    {{
                      $t(
                        "We empowers your marketing, sales and services teams to collaborate across the entire customer lifecycle for more meaningful, memorable experiences.",
                      )
                    }}
                  </h6>
                </section>
              </div>
            </v-tab-item>
          </v-tabs>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import imgAPI from "@/landing/static/images/imgAPI";
import Title from "../MainTitle";

export default {
  components: {
    TitleMain: Title,
  },
  data() {
    return {
      tab: null,
      imgAPI: imgAPI,
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>